import ProductInSummary from '../../Pages/Shop/Components/ProductComponents/ProductInSummary'
import { CheckBox } from 'devextreme-react/check-box';
import { useOrder } from '../../Providers/OrderProvider';
import { useAuth } from '../../Providers/AuthProvider';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useCart } from '../../Providers/CartProvider';
import { useOffers } from '../../Providers/OffersProvider';

const CartSummary = () => {
    const { cartItems, getBasketAsync } = useCart()
    const { authState } = useAuth()
    const { orderInfo } = useOrder()
    const { orderItemsFromOffer } = useOffers()

    useEffect(() => {
        if (!orderItemsFromOffer || orderItemsFromOffer.length <= 0) { //dla realizacji oferty nie przeliczamy ceny                
            calculateBasketPrice()
        }
    }, [])

    const calculateBasketPrice = async () => {
        toast.promise(getBasketAsync(), {
            pending: 'Trwa przeliczanie cen pozycji z koszyka...',
            success: 'Pomyślnie przeliczono ceny',
        })
    }

    const generateDataForInvoice = () => {
        const address = authState.user.isOperator ? authState.selectedCustomerData : authState.user.customerInfo[0]
        const tmpTax = address.tax ? address.tax : address.nip

        return (<>
            <h3>Dane do faktury</h3>
            <div className='d-flex flex-column mt-3'>
                {address.name} <br />
                {address.street} {address.houseNum} {address.localNum ? '/' + address.localNum : ''}<br />
                {address.zipCode} {address.city} <br />
                {`E-mail: ${address.email}`}<br />
                {`Telefon: ${address.phone}`}<br />
                {tmpTax ? 'NIP: ' + tmpTax : ''}
            </div>
        </>)
    }
    const generateSummary = () => {
        const filteredBasketItems = cartItems.basketItems && cartItems.basketItems.length > 0 ? cartItems.basketItems.filter(bi => bi.isSelected) : []
        const items = orderItemsFromOffer.length > 0 ? orderItemsFromOffer : filteredBasketItems
        if (items.length > 0) {
            return items.map((basketItem, index, arr) => (
                <ProductInSummary
                    key={index}
                    basketItem={basketItem}
                    isLastElement={index === arr.length - 1}
                />
            ))
        }
        else {
            return null
        }
    }


    if (!authState.user) {
        return null
    }
    return (
        <>
            <div className="main-container-holder">
                <h3 className='mt-3 mb-3 ms-5'>Podsumowanie zamówienia</h3>
                {generateSummary()}
            </div>
            <div className="main-container-holder mt-3">
                <div className="col-12 col-lg-6">
                    <h3>Dostawa</h3>
                    <CheckBox
                        textPosition="before"
                        text={orderInfo.deliveryType}
                        className="custom-checkbox mt-3 mb-3"
                        value={true}
                        readOnly={true}
                    />
                </div>
            </div>
            <div className="main-container-holder mt-3">
                <div className="col-12 col-lg-6">
                    <h3>Płatność</h3>
                    <CheckBox
                        textPosition="before"
                        text={orderInfo.payment}
                        className="custom-checkbox mt-3 mb-3"
                        value={true}
                        readOnly={true}
                    />
                </div>
            </div>
            <div className="main-container-holder mt-3">
                <div className="col-12 col-lg-6">
                    <h3>Dane do wysyłki</h3>
                    <div className='d-flex flex-column mt-3'>
                        {orderInfo.deliveryType === 'Odbiór w hurtowni' && <span>{orderInfo.deliveryAddress.id}</span>}
                        <span>{orderInfo.deliveryAddress.name}</span>
                        <span>{orderInfo.deliveryAddress.street}</span>
                        <span>{orderInfo.deliveryAddress.city}</span>
                        {orderInfo.deliveryAddress.email && orderInfo.deliveryAddress.email.trim() != '' && <span>{`E-mail: ${orderInfo.deliveryAddress.email}`}</span>}
                        {orderInfo.deliveryAddress.phoneNumber && orderInfo.deliveryAddress.phoneNumber.trim() != '' && <span>{`Telefon: ${orderInfo.deliveryAddress.phoneNumber}`}</span>}
                        <span>{orderInfo.deliveryAddress.whAddress}</span>
                    </div>
                </div>
            </div>
            <div className="main-container-holder mt-3">
                <div className="col-12 col-lg-6">
                    <div className='d-flex flex-column mt-3'>
                        <h3 className='mb-2'>Osoba upoważniona do odbioru towaru:</h3>
                        <span>{`${orderInfo.authorizedPersons.name} ${orderInfo.authorizedPersons.surname}`}</span>
                        <span>{`E-mail: ${orderInfo.authorizedPersons.email && orderInfo.authorizedPersons.email.trim() != '' ? orderInfo.authorizedPersons.email : ''}`}</span>
                        <span>{`Telefon: ${orderInfo.authorizedPersons.phoneNumber && orderInfo.authorizedPersons.phoneNumber.trim() != '' ? orderInfo.authorizedPersons.phoneNumber : ''}`}</span>
                        <span>{`Stanowisko: ${orderInfo.authorizedPersons.position && orderInfo.authorizedPersons.position.trim() != '' ? orderInfo.authorizedPersons.position : ''}`}</span>
                    </div>
                </div>
            </div>

            <div className="main-container-holder mt-3">
                <div className="col-12 col-lg-6 mt-4 mt-lg-0">
                    {generateDataForInvoice()}
                </div>
            </div>
        </>
    )
}

export default CartSummary